export default {
    methods: {
        currentLocale: function () {
            switch (this.currentLocaleIso2Code()) {
                case 'en':
                    return 'en_GB';
                case 'nl':
                    return 'nl-BE';
                case 'fr':
                    return 'fr-BE';
            }
        },

        currentLocaleIso2Code: function () {
            return this.$store.getters['localization/getCurrentLocale'];
        },

        getTranslations: function () {
            return this.$store.getters['localization/getTranslations'];
        },

        trans: function (key, replace = {}) {
            let translation = this._getNestedObjectKeyViaDotNotation(
                this.getTranslations(),
                key
            );

            if (translation) {
                return this._chainTranslationStringTransformers(
                    translation.split('|')[0],
                    replace
                );
            }

            return key;
        },

        trans_choice: function (key, number = 1, replace = {}) {
            let translation = this._getNestedObjectKeyViaDotNotation(
                this.getTranslations(),
                key
            );

            if (translation) {
                let pluralization =
                    translation.split('|').find((option, index) => {
                        const rangeOrNumber = option
                            .trim()
                            .match(/^\{(\d+)\}|\[(\d+),(\d+|\*)\]/);

                        if (!rangeOrNumber) {
                            // No range or number indicated, use the first one for singular and last one for plural
                            return number === 1
                                ? index === 0
                                : index === translation.split('|').length - 1;
                        }

                        if (rangeOrNumber[1]) {
                            // Exact number case like {0}
                            return number === parseInt(rangeOrNumber[1]);
                        }

                        if (rangeOrNumber[2] && rangeOrNumber[3]) {
                            // Range case like [1,19] or [20,*]
                            let rangeStart = parseInt(rangeOrNumber[2], 10);
                            let rangeEnd =
                                rangeOrNumber[3] === '*'
                                    ? Infinity
                                    : parseInt(rangeOrNumber[3], 10);

                            return number >= rangeStart && number <= rangeEnd;
                        }
                    }) || translation.split('|')[0];

                // Remove the range or number from the translation
                pluralization = pluralization
                    .trim()
                    .replace(/^\{(\d+)\}|\[(\d+),(\d+|\*)\]/, '');

                return this._chainTranslationStringTransformers(
                    pluralization,
                    replace
                );
            }

            return key;
        },

        _replaceInTranslation: function (translation, replace = {}) {
            Object.entries(replace).forEach(([key, value]) => {
                translation = translation.replace(`:${key}`, value);
            });

            return translation;
        },

        _getNestedObjectKeyViaDotNotation: function (object, key) {
            try {
                return key.split('.').reduce((o, i) => o[i], object);
            } catch (e) {
                return key;
            }
        },

        _htmlEntities: function (str) {
            return String(str).replace(/&#(\d+);/g, function (match, dec) {
                return String.fromCharCode(dec);
            });
        },

        _chainTranslationStringTransformers: function (translation, replace) {
            translation = this._replaceInTranslation(translation, replace);
            translation = this._htmlEntities(translation);

            return translation.trim();
        },
    },
};
